module.exports = __webpack_public_path__ + "media/images/gallery/open_clusters/M_45/M_45_vis-74fc1919a49e61ffe75e576ee5caf9f4.jpg";